import { authApi } from '@/api/endpoints'
import { useAuthStore } from '@/store/authStore'
import { announceLogout } from '@/lib/soundLeader'

/**
 * #235 — log out locally and ask the server to end this session.
 *
 * The server call is fire-and-forget: local state is cleared at once, whatever the request does
 * (slow, failing, or throwing). Without the call, the refresh token kept working server-side for
 * up to 30 days after a dashboard logout.
 *
 * #294 redesign — and tell the other tabs of this browser (only here: the user's own logout).
 */
export function logoutAndEndSession(): void {
  const { accessToken, refreshToken, logout } = useAuthStore.getState()
  if (refreshToken) {
    try {
      Promise.resolve(authApi.endSession(refreshToken, accessToken)).catch(() => {})
    } catch {
      // never let the server call stand in the way of a local logout
    }
  }
  // #294 redesign — the user's own logout reaches the other tabs of this browser: they log out too and
  // the critical sound stops everywhere at once. (A logout the API client forces is not announced; #334 — it
  // reaches the other tabs through the stored login copy instead, as this logout does too.)
  announceLogout()
  logout()
}
